export const stringToNumber = (value?: string | number): number | null =>
  typeof value === 'number' ? value : parseFloat(value) || null;

export const toCapitalize = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);

export const isEmpty = (field: unknown): boolean => field === undefined || field === null;
